import GlMap from './gl-map.vue'
export default GlMap
